/**
 * gtag.ts — Minimal GA4 event helpers for the CiteOps.ai dashboard.
 *
 * Relies on the gtag snippet loaded in index.html via VITE_GA4_MEASUREMENT_ID.
 * All functions are no-ops when gtag is unavailable (snippet not loaded or
 * measurement ID not configured), so they are safe to call unconditionally.
 */

declare global {
  interface Window {
    gtag: (command: string, ...args: unknown[]) => void
    dataLayer: unknown[]
  }
}

function isGtagAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.gtag === 'function'
}

/** Send a page_view event with the current path. */
export function gtagPageview(path: string): void {
  if (!isGtagAvailable()) return
  window.gtag('event', 'page_view', { page_path: path })
}

/** Send a named GA4 event with optional parameters. */
export function gtagEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>,
): void {
  if (!isGtagAvailable()) return
  window.gtag('event', eventName, params)
}
